const env = {}

env.resellerApi = process.env.REACT_APP_RESELLER_API
env.apiPrefix = process.env.REACT_APP_API_PREFIX
env.storeApi = process.env.REACT_APP_STORE_API
env.googleMapApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
env.domain = process.env.REACT_APP_DOMAIN
env.applicationStage = process.env.REACT_APP_STAGE
env.fbaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY
env.fbaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
env.fbaseProjectID = process.env.REACT_APP_FIREBASE_PROJECTID
env.fbaseStoreBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
env.fbaseMsgID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
env.fbaseAppID = process.env.REACT_APP_FIREBASE_APP_ID
env.fbaseMeasureID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
env.fbaseVapiKey = process.env.REACT_APP_FIREBASE_USE_PUBLIC_VAPI_KEY

env.isDev = process.env.NODE_ENV === 'development'

export default env
